<div class="flex-column h-100">
  <odx-content-box class="w-100">
    <app-configuration-wizard-header-accordion
      [showCosts]="showCosts"
      [selectedData]="headerProducts"
      [prefix]="headerAccordionPrefix"
      [title]="transmitter ? (transmitter | localizeProductName) : ''"
    ></app-configuration-wizard-header-accordion>
  </odx-content-box>
  @if (transmitter) {
    <div class="configuration-wizard-header flex-column space-top">
      <h5
        class="odx-title-5"
        i18n="@@transmitterConfiguration.selectSensor.header"
        data-testid="transmitterConfiguration.selectSensor.header"
      >
        Sensor auswählen
      </h5>

      <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    </div>
    <odx-content-box odxLayout="flex" class="flex-column flex-scroll">
      @if (transmitter.isModular) {
        <form [formGroup]="selectedSensorForm" class="overflow-hidden h-100">
          @if (filteredSensors$ | async; as sensors) {
            @if (sensors.length > 0) {
              <odx-radio-group formControlName="selectedSensor" required="true" class="overflow-hidden h-100 no-padding-left">
                <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="mb-36 w-100">
                  @for (sensor of sensors; track sensor) {
                    <app-product-card
                      class="overflow-hidden"
                      [product]="sensor"
                      [showCosts]="showCosts"
                      [isSelected]="selectedSensor?.id === sensor.id"
                      (click)="select(sensor)"
                      (select$)="select(sensor)"
                      selectionMode="single"
                    >
                      @if (sensor.id) {
                        <div class="feature">
                          <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                          <p class="odx-text--small">{{ sensor.id }}</p>
                        </div>
                      }
                    </app-product-card>
                  }
                </div>
              </odx-radio-group>
            } @else {
              <app-refresh-products-hint dataType="Sensoren" i18n-dataType="@@global.sensors"></app-refresh-products-hint>
            }
          }
        </form>
      }
    </odx-content-box>
  }
</div>
